module.exports = __webpack_public_path__ + "img/electronic_enabled.f535da47.svg";